import { render } from "./NewCompanyModal.vue?vue&type=template&id=0b2bedbd"
import script from "./NewCompanyModal.vue?vue&type=script&lang=js"
export * from "./NewCompanyModal.vue?vue&type=script&lang=js"

import "./NewCompanyModal.vue?vue&type=style&index=0&id=0b2bedbd&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__